import React, { useState } from "react";

function GreetingForm({ onNewGreeting }) {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !message.trim()) return;

    try {
      const response = await fetch("/api/greetings", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, message }),
      });

      if (response.ok) {
        const savedGreeting = await response.json();
        onNewGreeting(savedGreeting); // 💡 Lisää uusi tervehdys heti näkymään
        setName("");
        setMessage("");
      } else {
        console.error("Virhe tallennettaessa tervehdystä");
      }
    } catch (err) {
      console.error("Virhe lähetyksessä:", err);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        placeholder="Nimesi"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <input
        placeholder="Tervehdys"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />
      <button type="submit">Lähetä</button>
    </form>
  );
}

export default GreetingForm;
